module.exports = __webpack_public_path__ + "static/media/ioxhost.c10c3a6b.svg";